/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

const uploadImage = async (imageSrc : any) => {

  const base64Data = imageSrc.split(',')[1];
  const blob = await fetch(`data:image/jpeg;base64,${base64Data}`).then((res) => res.blob());

  // Create a FormData object and append the image file
  const formData = new FormData();
  formData.append('file', blob, 'captured_image.jpeg');

    try {
      const response = await axiosInstance.post(`${baseUrl}/files/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-auth-token': authToken,
          'x-userid': authUserID
        }})

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


const downloadImage = async (
    file_id: any
  ) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/files/download?file_id=${file_id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getPrnFiles =  async (fileName: any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/uploads/qr/areas/${fileName}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }




const FileService = {
    uploadImage,
    downloadImage,
    getPrnFiles
};
  


export {FileService}